import React, { useRef } from 'react';
import './Reviews.css';
import { FaStar, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import review1 from './assets/review1.png';
import review2 from './assets/review2.png';
import review3 from './assets/review3.png';
import review4 from './assets/review4.png';
import review5 from './assets/review5.png';
import { useTranslation } from 'react-i18next';

const Reviews = () => {
  const { t } = useTranslation();
  const scrollContainerRef = useRef(null);
  const offset = 300;

  const reviewsData = [
    { username: t('verified_purchase'), image: review1, date: '25.05.2025' },
    { username: t('verified_purchase'), image: review2, date: '19.05.2025' },
    { username: t('verified_purchase'), image: review3, date: '19.05.2025' },
    { username: t('verified_purchase'), image: review4, date: '16.05.2025' },
    { username: t('verified_purchase'), image: review5, date: '03.05.2025' },
  ];

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, clientWidth, scrollWidth } = scrollContainerRef.current;
      let newScrollLeft = scrollLeft + offset;
      if (newScrollLeft > scrollWidth - clientWidth) newScrollLeft = 0;
      scrollContainerRef.current.scrollTo({ left: newScrollLeft, behavior: 'smooth' });
    }
  };

  const scrollLeftFunc = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, clientWidth, scrollWidth } = scrollContainerRef.current;
      let newScrollLeft = scrollLeft - offset;
      if (newScrollLeft < 0) newScrollLeft = scrollWidth - clientWidth;
      scrollContainerRef.current.scrollTo({ left: newScrollLeft, behavior: 'smooth' });
    }
  };

  return (
    <div className="reviews-component" id="reviews">
      <div className="reviews-inner">
        <h2>{t('reviews_heading')}</h2>
        <p className="reviews-subtitle">{t('reviews_subtitle')}</p>
        <div className="reviews-slider-container">
          <button className="slider-arrow left" onClick={scrollLeftFunc}>
            <FaChevronLeft />
          </button>
          <div className="reviews-boxes" ref={scrollContainerRef}>
            {reviewsData.map((review, index) => (
              <div key={index} className="review-box">
                <div className="review-stars">
                  {[...Array(5)].map((_, i) => <FaStar key={i} className="star-icon" />)}
                </div>
                <img className="review-image" src={review.image} alt={`EAGLE SCRIPT customer review ${index + 1} - User testimonial`} loading="lazy" />
                <div className="review-footer">
                  <span className="review-username">{review.username}</span>
                  <span className="review-date">| {review.date}</span>
                </div>
              </div>
            ))}
          </div>
          <button className="slider-arrow right" onClick={scrollRight}>
            <FaChevronRight />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
